module.exports = __webpack_public_path__ + "static/img/banner1.132620e0.jpg";